import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-ketto',
  templateUrl: './why-ketto.component.html',
  styleUrls: ['./why-ketto.component.scss']
})
export class WhyKettoComponent implements OnInit {
  whyKetto = [
    { imgpath: '../assets/images/verifiedketto.png', sub: 'Verified Campaigns' },
    { imgpath: '../assets/images/moneybag.png', sub: 'Tax Deductible' },
    { imgpath: '../assets/images/shieldtick.png', sub: 'Secure Transactions' }
  ]

  constructor(
  ) { }

  ngOnInit(): void {
  }

}
